import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from "react-router-dom";
import SignIn from './SignIn';
import GridButtons from './GridButtons';
import Code from './Code';

import '../../css/jb-styles.css';

import CircleIcon from '@mui/icons-material/Circle';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import BackspaceOutlinedIcon from '@mui/icons-material/BackspaceOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import {
  gridArray,
  incrementGridArray,
  decrementGridArray,
  rightSwipeIncrement,
  leftSwipeIncrement,
  clickCount,
  undoCount,
  resetTestCodeArray,
  resetCodeNumber,
  resetClickCount,
  isTest,
  setTestCode,
} from '../../../redux/challengeSlice';

export default function JoystickChallenge() {

  const [clicked, setClicked] = useState(0);
  const [displayMessage, setDisplayMessage] = useState(null);
  const [disableButtons, setDisableButtons] = useState(false);
  const [message, setMessage] = useState('');


  // Animation states
  const [isAnimating, setIsAnimating] = useState(false);

  // Available states - idle or animating
  const [animationPhase, setAnimationPhase] = useState("idle");

  // Available states - ascending, descending, null
  const [animationDirection, setAnimationDirection] = useState(null);

  // show me states
  const [showIncrementButton, setShowIncrementButton] = useState(false);
  const [showDecrementButton, setShowDecrementButton] = useState(false);
  const [showSelectButton, setShowSelectButton] = useState(false);
  const [showUnlockButton, setShowUnlockButton] = useState(false);
  const [showSelectorCell, setShowSelectorCell] = useState(false);
  const [showGridCell, setShowGridCell] = useState(false);

  const gridArrayState = useSelector((state) => state.challenge.gridArray);
  const incrementGridArrayState = useSelector((state) => state.challenge.incrementGridArray);
  const decrementGridArrayState = useSelector((state) => state.challenge.decrementGridArray);
  const registeredPatternState = useSelector((state) => state.challenge.registeredPattern);
  const signinResultState = useSelector((state) => state.challenge.signinResult);
  const isTestState = useSelector((state) => state.challenge.isTest);
  const selectedCellState = useSelector((state) => state.challenge.selectedCell);
  const codeArrayState = useSelector((state) => state.challenge.codeArray);
  const [nextCell, setNextCell] = useState(false);
  const [patternCount, setPatternCount] = useState(0);

  const [currentGrid, setCurrentGrid] = useState(gridArrayState);
  // const [bob, setBob] = useState(gridArrayState);

  const containerRef = React.useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // useEffect(() => {
  //   console.log('grid: ', grid);
  // }, [grid]);

  // function* generate_iterations() {
  //   yield registeredPatternState[0];
  //   yield registeredPatternState[1];
  //   yield registeredPatternState[2];
  //   yield registeredPatternState[3];
  //   yield registeredPatternState[4];
  //   yield registeredPatternState[5];
  // }

  // const generator = generate_iterations();

  useEffect(() => {
    console.log('nextCell in useEffect: ', nextCell);
    // if (nextCell === true) {
    if (nextCell === true && patternCount < 6) {
      // console.log('currentGrid in useEffect: ', currentGrid);
      setShowGridCell(true);
      createSwipes(registeredPatternState[patternCount], currentGrid);
      setPatternCount(patternCount + 1);
      setNextCell(false);
    }
    if (nextCell == true && patternCount == 6) {
      setShowUnlockButton(true);
      dispatch(isTest(true));
      setTimeout(() => {
        // console.log('UNLOCK');
        // navigate("/success");
        setShowUnlockButton(false);
        // result();
        unlock();
      }, 2000);
    }
  }, [nextCell]);
  // }, [currentGrid]);
  // }, [currentGrid, nextCell]);

  useEffect(() => {
    console.log('currentGrid: ', currentGrid);
    // }, [nextCell]);
  }, [currentGrid]);

  useEffect(() => {
    console.log('patternCount: ', patternCount);
    // if (patternCount == 6) {
    //   setShowUnlockButton(true);
    //   dispatch(isTest(true));
    //   setTimeout(() => {
    //     // console.log('UNLOCK');
    //     // navigate("/success");
    //     setShowUnlockButton(false);
    //     // result();
    //     unlock();
    //   }, 1000);
    // }
  }, [patternCount]);

  useEffect(() => {
    // console.log('clicked: ', clicked);
  }, [clicked]);

  useEffect(() => {
    // console.log('gridArrayState: ', gridArrayState);
    setCurrentGrid(gridArrayState);
  }, [gridArrayState]);

  useEffect(() => {
    // console.log('isTestState: ', isTestState);
  }, [isTestState]);

  useEffect(() => {
    if (incrementGridArrayState.length == 0) {
      // Do nothing
    } else {
      dispatch(gridArray(incrementGridArrayState));
      dispatch(rightSwipeIncrement());
    }
  }, [incrementGridArrayState]);

  useEffect(() => {
    if (decrementGridArrayState.length == 0) {
      // Do nothing
    } else {
      dispatch(gridArray(decrementGridArrayState));
      dispatch(leftSwipeIncrement());
    }
  }, [decrementGridArrayState]);

  useEffect(() => {
    // console.log('animationDirection: ', animationDirection);
    // console.log('animationPhase: ', animationPhase);
  }, [animationDirection, animationPhase]);

  useEffect(() => {

  }, [displayMessage, message]);

  const incrementGridArrayHandler = () => {

    if (isAnimating) return;
    setIsAnimating(true);

    setAnimationPhase("animating")
    setAnimationDirection('ascending');
    dispatch(incrementGridArray());

    setTimeout(() => {
      setAnimationDirection(null)
      setAnimationPhase("idle")
      setIsAnimating(false)
    }, 300)

  };

  const decrementGridArrayHandler = () => {

    if (isAnimating) return;
    setIsAnimating(true);

    setAnimationPhase("animating")
    setAnimationDirection('descending');
    dispatch(decrementGridArray());

    setTimeout(() => {
      setAnimationDirection(null)
      setAnimationPhase("idle")
      setIsAnimating(false)
    }, 300)
  };

  const createCellClassName = (rowIndex, columnIndex) => {
    let cellClassName = '';

    switch (rowIndex) {
      case 0:
      case 5:
        switch (columnIndex) {
          case 0:
          case 5:
            cellClassName = 'jb-border-200';
            break;
          default:
            cellClassName = 'jb-border-200';
        }
        break;
      case 1:
      case 4:
        switch (columnIndex) {
          case 0:
          case 5:
            cellClassName = 'jb-border-200';
            break;
          case 1:
          case 4:
          case 2:
          case 3:
            cellClassName = 'jb-border-400';
            break;
          default:
            cellClassName = 'jb-border-200';
        }
        break;
      case 2:
      case 3:
        switch (columnIndex) {
          case 0:
          case 5:
            cellClassName = 'jb-border-200';
            break;
          case 1:
          case 4:
            cellClassName = 'jb-border-400';
            break;
          case 2:
          case 3:
            cellClassName = 'jb-border-300';
            break;
          default:
            cellClassName = 'jb-border-200';
        }
        break;
      default:
        cellClassName = 'jb-border-200';
    }

    return cellClassName;
  }

  const clickHandler = () => {

    console.log('CLICK');

    if (registeredPatternState.length == 0) {
      alert('Please set pattern first');
      return;
    }

    dispatch(clickCount());
    setClicked(clicked + 1);
  };

  const undo = () => {
    dispatch(undoCount());
    setClicked(clicked - 1);
  };

  const result = () => {

    if (isTestState) {
      console.log('This was a test');
      if (signinResultState == true) {
        setMessage('Success - save your pattern');
        setDisplayMessage(true);
        challengeSuccessTimer();
      } else {
        setMessage('Failure -  reset and try again');
        setDisplayMessage(false);
        challengeFailureTimer();
      }
    } else {
      console.log('This was not a test')
      if (signinResultState == true) {
        resetChallenge();
        navigate("/success");
      } else {
        resetChallenge();
        navigate("/failure");
      }
    }
  };

  const challengeSuccessTimer = () => {
    setDisableButtons(true);
    setTimeout(() => {
      resetChallenge();
      if (isTestState) {
        dispatch(isTest(false));
      }
    }, 2000);
  };

  const challengeFailureTimer = () => {
    setDisableButtons(true);
    setTimeout(() => {
      resetChallenge();
      if (isTestState) {
        dispatch(isTest(false));
      }
    }, 5000);
  };

  const resetChallenge = () => {
    dispatch(resetClickCount(0));
    setClicked(null);
    dispatch(resetCodeNumber(null));
    dispatch(resetTestCodeArray([]));
    setDisplayMessage(null);
    setDisableButtons(false);
  };

  // const highlightSelect = () => {
  //   setShowSelectButton(true);
  //   setTimeout(() => {
  //     dispatch(clickCount());
  //     setClicked(clicked + 1);
  //     setShowSelectButton(false);
  //   }, 500);
  // };

  const highlightIncrement = () => {
    setShowIncrementButton(true);
    setTimeout(() => {
      setShowIncrementButton(false);
    }, 200);
  }

  const highlightDecrement = () => {
    setShowDecrementButton(true);
    setTimeout(() => {
      setShowDecrementButton(false);
    }, 200);
  };

  const highlightCorrectCell = (row, col) => {

  };

  const unlock = () => {
    result();
  };

  const showIncrement = () => {
    incrementGridArrayHandler();
  };

  const showDecrement = () => {
    decrementGridArrayHandler();
  };

  const do_swipe_timeout = (direction, steps, delay = 500, index = 0) => {
    // console.log('DELAY: ', delay);

    if (steps == 0) {
      // console.log('In steps == 0: ', steps);

      setShowSelectButton(true);
      setTimeout(() => {
        dispatch(clickCount());
        setClicked(clicked + 1);
        setShowSelectButton(false);
        setNextCell(true);
      }, 1000);

    }
    if (index < steps) {
      setTimeout(function () {
        if (direction == 'inc') {
          highlightIncrement();
          showIncrement();
        } else {
          highlightDecrement();
          showDecrement();
        }
        if (index + 1 == steps) {
          setShowSelectButton(true);
          setTimeout(() => {
            dispatch(clickCount());
            setClicked(clicked + 1);
            setShowSelectButton(false);
            setNextCell(true);
          }, 1000);
        }
        do_swipe_timeout(direction, steps, delay, ++index);
      }, delay);
    }

  };

  const createSwipes = ((cell, gridNumbers) => {

    // console.log('cell: ', cell);
    // console.log('gridNumbers: ', gridNumbers);

    if (gridNumbers[cell[0]][cell[1]] == codeArrayState[selectedCellState]) {
      console.log('grid cell equals the selected cell number');
      do_swipe_timeout('inc', 0, 2000, 0);
    } else {
      // if ((codeArrayState[selectedCellState] - gridNumbers[cell[0]][cell[1]] >= (codeArrayState[selectedCellState] % 3))) {
      // if ((codeArrayState[selectedCellState] - gridNumbers[cell[0]][cell[1]] >= (codeArrayState[selectedCellState]))) {
      if ((codeArrayState[selectedCellState] - gridNumbers[cell[0]][cell[1]] >= 0)) {
        console.log('increment - steps: ', Math.abs(codeArrayState[selectedCellState] - gridNumbers[cell[0]][cell[1]]));
        do_swipe_timeout('inc', Math.abs(codeArrayState[selectedCellState] - gridNumbers[cell[0]][cell[1]]), 2000, 0);
      } else {
        console.log('decrement - steps: ', Math.abs(codeArrayState[selectedCellState] - gridNumbers[cell[0]][cell[1]]));
        do_swipe_timeout('dec', Math.abs(codeArrayState[selectedCellState] - gridNumbers[cell[0]][cell[1]]), 2000, 0);
      }
    }

  });

  const show = () => {
    // console.log('In show');
    setPatternCount(0);
    setShowSelectorCell(true);
    setNextCell(true);
  }

  const normalGridCellStyling = {
    padding: '10px',
    width: '15%',
    aspectRatio: '1 / 1',
    color: '#3B4E68',
    overflow: 'hidden',
  };

  const showGridCellStyling = {
    // padding: '10px',
    width: '15%',
    aspectRatio: '1 / 1',
    color: '#3B4E68',
    overflow: 'hidden',
    borderColor: '#3b4e68',
    borderWidth: '2px',
    borderStyle: 'solid',
    backgroundColor: '#FFFFFF',
    padding: '6px',
  };

  const correctCellStyling = {
    // padding: '10px',
    backgroundColor: '#3B4E68',
    padding: '10px',
    width: '15%',
    aspectRatio: '1 / 1',
    color: '#FFFFFF',
    overflow: 'hidden',
    borderColor: '#3b4e68',
    borderWidth: '2px',
    borderStyle: 'solid',
    padding: '6px',
  };

  return (

    <React.Fragment>

      <Code location='joystick' showSelectorCell={showSelectorCell} />

      <Box
        id='vauth-swipe-grid-container'
        sx={{
          padding: '20px',
          paddingBottom: 0,
          paddingTop: '10px',
          width: '100%',
          alignSelf: 'center',
          userSelect: 'none',
          cursor: 'pointer',
        }}
      >

        {gridArrayState.map((row, rowIndex) => (
          <Box
            key={`grid-row${rowIndex}`}
            id={`grid-row${rowIndex}`}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '5px',
            }}>
            {row.map((cell, columnIndex) => (
              <Box
                key={`grid-column${columnIndex}`}
                className={`card jb-cell ${createCellClassName(rowIndex, columnIndex)}`}
                id={`cell-${rowIndex}-${columnIndex}`}
                // NEED STYLING HERE
                // sx={showGridCell && rowIndex == registeredPatternState[patternCount - 1][0] && columnIndex == registeredPatternState[patternCount - 1][1] ? showGridCellStyling : normalGridCellStyling}
                style={patternCount > 1 && rowIndex == registeredPatternState[0][0] && columnIndex == registeredPatternState[0][1] ? correctCellStyling :
                  patternCount > 2 && rowIndex == registeredPatternState[1][0] && columnIndex == registeredPatternState[1][1] ? correctCellStyling :
                    patternCount > 3 && rowIndex == registeredPatternState[2][0] && columnIndex == registeredPatternState[2][1] ? correctCellStyling :
                      patternCount > 4 && rowIndex == registeredPatternState[3][0] && columnIndex == registeredPatternState[3][1] ? correctCellStyling :
                        patternCount > 5 && rowIndex == registeredPatternState[4][0] && columnIndex == registeredPatternState[4][1] ? correctCellStyling :
                          // patternCount > 6 && rowIndex == registeredPatternState[5][0] && columnIndex == registeredPatternState[5][1] ? correctCellStyling :
                          patternCount == 6 && cell == codeArrayState[selectedCellState] && rowIndex == registeredPatternState[5][0] && columnIndex == registeredPatternState[5][1] ? correctCellStyling :
                            normalGridCellStyling}
                sx={showGridCell && rowIndex == registeredPatternState[patternCount - 1][0] && columnIndex == registeredPatternState[patternCount - 1][1] ? showGridCellStyling : normalGridCellStyling}
                ref={containerRef}
              >
                {(animationPhase === "idle" || animationPhase === "animating") && (
                  <Box
                    sx={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      // backgroundColor: 'green',
                    }}
                    className={`${animationPhase === "animating"
                      ? animationDirection === "ascending"
                        // ? "animate-fade-out-right animate-fade-in-from-left"
                        // : "animate-fade-out-left animate-fade-in-from-right"
                        ? "animate-fade-in-from-left"
                        : "animate-fade-in-from-right"
                      : ""
                      }`}
                  >
                    <Cell
                      cell={cell}
                      animationPhase={animationPhase}
                      animationDirection={animationDirection}
                    />
                  </Box>
                )}

              </Box>
            ))}
          </Box>
        ))
        }

      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: '20px',
          paddingLeft: '20px',
          paddingRight: '20px',
        }}
      >


        <Box
          className='show-button'
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >

          <IconButton
            aria-label="show"
            onClick={show}
            sx={{
              paddingLeft: '0px',
            }}
          >
            <HelpOutlineIcon
              size='large'
              sx={{
                color: '#3B4E68',
                fontSize: '2.5rem',
                stroke: "white",
                strokeWidth: "1px",
              }}
            />
          </IconButton>

        </Box>


        {displayMessage == null ?
          <React.Fragment>
            <Box
              sx={{
                width: '10%',
              }}
            >
              {clicked > 0 ?
                <CircleIcon
                  sx={{
                    color: '#3B4E68',
                  }} />
                :
                <CircleOutlinedIcon
                  sx={{
                    color: '#3B4E68',
                  }} />}

            </Box>

            <Box
              sx={{
                width: '10%',
              }}
            >
              {clicked > 1 ?
                <CircleIcon
                  sx={{
                    color: '#3B4E68',
                  }} />
                :
                <CircleOutlinedIcon
                  sx={{
                    color: '#3B4E68',
                  }} />}

            </Box>

            <Box
              sx={{
                width: '10%',
              }}
            >
              {clicked > 2 ?
                <CircleIcon
                  sx={{
                    color: '#3B4E68',
                  }} />
                :
                <CircleOutlinedIcon
                  sx={{
                    color: '#3B4E68',
                  }} />}
            </Box>

            <Box
              sx={{
                width: '10%',
              }}
            >
              {clicked > 3 ?
                <CircleIcon
                  sx={{
                    color: '#3B4E68',
                  }} />
                :
                <CircleOutlinedIcon
                  sx={{
                    color: '#3B4E68',
                  }} />}
            </Box>

            <Box
              sx={{
                width: '10%',
              }}
            >
              {clicked > 4 ?
                <CircleIcon
                  sx={{
                    color: '#3B4E68',
                  }} />
                :
                <CircleOutlinedIcon
                  sx={{
                    color: '#3B4E68',
                  }} />}
            </Box>

            <Box
              sx={{
                width: '10%',
              }}
            >
              {clicked > 5 ?
                <CircleIcon
                  sx={{
                    color: '#3B4E68',
                  }} />
                :
                <CircleOutlinedIcon
                  sx={{
                    color: '#3B4E68',
                  }} />}
            </Box>
          </React.Fragment>
          : displayMessage == true
            ? <Box
              sx={{
                color: 'green',
                width: '100%',
              }}
            >
              {message}
            </Box>
            :
            <Box
              sx={{
                color: 'red',
                width: '100%',
              }}
            >
              {message}
            </Box>
        }


        <Box
          className='undo-button'
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >

          <IconButton
            aria-label="undo"
            onClick={undo}
          >
            <BackspaceOutlinedIcon
              size='large'
              sx={{
                color: '#3B4E68',
                fontSize: '2.5rem',
                stroke: "white",
                strokeWidth: "1px",
              }}
            />
          </IconButton>

        </Box>

      </Box>

      <GridButtons
        onTap={clickHandler}
        location='joystick'
        disable={disableButtons}
        decrement={decrementGridArrayHandler}
        increment={incrementGridArrayHandler}
        showIncrementButton={showIncrementButton}
        showDecrementButton={showDecrementButton}
        showSelectButton={showSelectButton}
      />
      <SignIn
        clicked={clicked}
        handler={result}
        disable={disableButtons}
        showUnlockButton={showUnlockButton}
      />

    </React.Fragment >

  )
}

function Cell(props) {

  // console.log('clickCount: ', props.cell);
  // console.log('props: ', props);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      className={`${props.animationPhase === "animating"
        ? props.animationDirection === "ascending"
          // ? "animate-fade-out-right animate-fade-in-from-left"
          // : "animate-fade-out-left animate-fade-in-from-right"
          ? "animate-fade-in-from-left"
          : "animate-fade-in-from-right"
        : ""
        }`}
    >
      {props.cell}
    </Box>
  );
}
